export default __webpack_public_path__ + "static/media/resume-photobook.c0b24551.png";